// SPDX-License-Identifier: Apache-2.0 AND LicenseRef-Pachamama-Proprietary
// Copyright 2026 The Zyra Project
// Modifications copyright 2026 Pachamama Studios B.V. All rights reserved.

/**
 * ISO 8601 durations on the SPA side (`parseIsoDurationMs`), for the
 * Browse panel's cadence labels. AYNI: the frame-query resolver that
 * lived here served terraviz's assistant and went with it (2026-10-03).
 */

const MS_PER_GREGORIAN_YEAR = 365.2425 * 86_400_000
const MS_PER_GREGORIAN_MONTH = MS_PER_GREGORIAN_YEAR / 12
const DURATION_PATTERN =
  /^P(?:(\d+(?:\.\d+)?)Y)?(?:(\d+(?:\.\d+)?)M)?(?:(\d+(?:\.\d+)?)W)?(?:(\d+(?:\.\d+)?)D)?(?:T(?:(\d+(?:\.\d+)?)H)?(?:(\d+(?:\.\d+)?)M)?(?:(\d+(?:\.\d+)?)S)?)?$/

/** SPA-side mirror of the server's `parseIsoDuration`. Scoped to
 *  what frame-query resolution needs — return milliseconds or
 *  null. Bare `P` / `PT` fail-close rather than returning zero,
 *  matching the server policy. */
export function parseIsoDurationMs(input: string | undefined): number | null {
  if (!input) return null
  const match = DURATION_PATTERN.exec(input)
  if (!match) return null
  const [, y, mo, w, d, h, mi, s] = match
  if (!y && !mo && !w && !d && !h && !mi && !s) return null
  let ms = 0
  if (y) ms += parseFloat(y) * MS_PER_GREGORIAN_YEAR
  if (mo) ms += parseFloat(mo) * MS_PER_GREGORIAN_MONTH
  if (w) ms += parseFloat(w) * 7 * 86_400_000
  if (d) ms += parseFloat(d) * 86_400_000
  if (h) ms += parseFloat(h) * 3_600_000
  if (mi) ms += parseFloat(mi) * 60_000
  if (s) ms += parseFloat(s) * 1000
  return ms
}
